<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <!-- <div class="title">订单管理</div> -->
      <div class="v-refresh" @click="refresh">刷新</div>
      <div class="v-text">今日桌数：<span>{{statisticsInfo.count_today}}</span></div>
      <div class="v-text">今日累计消费：<span>￥{{statisticsInfo.amout_today}}</span></div>
      <!-- <div class="v-text">共计原价：<span>￥{{statisticsInfo.amout_today}}</span></div> -->
      <el-button @click="handleAllAffirm" type="info">确认本页</el-button>
      <el-button @click="handleWithhold" type="danger">扣款</el-button>
      <el-button @click="handleVerify" type="warning">优惠劵验证</el-button>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table v-loading="isLoading" :data="tableData" stripe highlight-current-row>
            <el-table-column label="序号" type="index" width="50" align="center">
              <template slot-scope="scope">
                <span>{{(page - 1) * pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="220px" label="下单时间">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px;">{{ scope.row.createtime }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100px" label="头像">
              <template slot-scope="scope">
                <img class="table-img" :src="scope.row.member_wxheadurl" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="姓名">
              <template slot-scope="scope">
                <span v-if="scope.row.member_name!==''">{{ scope.row.member_name }}</span>
                <span v-else>{{ scope.row.member_wxname }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="type" align="center" label="会员类型">
              <span>普通会员</span>
            </el-table-column> -->
            <el-table-column align="center" label="结账方式">
              <template slot-scope="scope">
                <span>{{ spendtypeChange(scope.row.spendtype) }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="member_mid" align="center" label="ID">
            </el-table-column>
            <el-table-column prop="member_mobile" align="center" label="手机号">
            </el-table-column>
            <el-table-column align="center" label="支付金额" min-width="160">
              <template slot-scope="scope">
                <span>已支付 {{ scope.row.amount }} 元</span>
                <span style="font-size: 12px;color:#999;margin-left: 8px;">（余额支付）</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="250px" label="确认金额">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="handleAffirm(scope.row.id)">未确认</el-button>
                <!-- <el-button size="mini" @click="handleEdit(scope.row.member_mid)">修改</el-button> -->
                <el-button size="mini" @click="handleRemark(scope.row)">备注</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" layout="prev, pager, next" :current-page="page" :page-size="pageSize" :total="total">
      </el-pagination>
    </el-container>
    <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-input type="textarea" v-model="desc"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleAffirmRemark">确 定</el-button>
      </span>
    </el-dialog>
    <withhold-modal ref="modalWithhold" @ok="modalWithholdOk"></withhold-modal>
    <verify-modal ref="modalVerify"></verify-modal>
    <el-dialog class="dialog-container" title="验证优惠劵" :visible.sync="pushDialogVisible">
      <div class="dialog-search-btn">
        <el-input v-model="pushmemberInfo.cdkey" clearable placeholder=""></el-input>
      </div>
      <el-divider content-position="left">优惠劵信息</el-divider>
      <span v-if="pushmemberInfo.member_name !==''" style="margin-left:85px;" class="span-divider">姓名：{{pushmemberInfo.member_name}}</span>
      <span v-else style="margin-left:85px;" class="span-divider">姓名：{{pushmemberInfo.member_wxname}}</span>
      <span class="span-divider">ID：{{pushmemberInfo.member_mid}}</span>
      <span class="span-divider">手机号：{{pushmemberInfo.member_mobile}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">优惠劵名：{{pushmemberInfo.coupon_name}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">获取方式：{{pushmemberInfo.coupon_description}}</span>
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">有效时间：{{pushmemberInfo.starttime}} ~ {{pushmemberInfo.endtime}}</span>
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">状态：{{ statusChange(pushmemberInfo)}}</span><br />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlePushAffirm">确 认</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { getWebsocketToken, lastSpend, confirmSpend, handleSpend, spendStatistics, setSpendRemark } from '@/views/webpc/CashierDesk/RealApp/apis'
import WithholdModal from './modules/WithholdModal'
import VerifyModal from './modules/verifyModal'
export default {
  components: { WithholdModal, VerifyModal },
  data () {
    return {
      isLoading: false,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      statisticsInfo: {},
      dialogVisible: false,
      pushDialogVisible: false,
      desc: '',
      params: {},
      token: '',
      pushId: '',
      pushmemberInfo: {}
    }
  },
  methods: {
    isUndue (value) {
      let times = new Date(value).getTime()
      let timesCurrent = new Date().getTime()
      if (parseInt(times) > parseInt(timesCurrent)) {
        return true
      } else {
        return false
      }
    },
    isOverdue (value) {
      let times = new Date(value).getTime()
      let timesCurrent = new Date().getTime()
      if (parseInt(times) < parseInt(timesCurrent)) {
        return true
      } else {
        return false
      }
    },
    // 状态
    statusChange (obj) {
      let status = parseInt(obj.status)
      if (status === 2) {
        return '已作废'
      }
      if (status === 3) {
        return '已过期'
      }
      if (status === 1) {
        return '已使用'
      }
      if (this.isUndue(obj.starttime)) {
        return '未到期'
      }
      if (status === 0) {
        return '未使用'
      }
    },
    // 结账方式
    spendtypeChange (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '个人余额'
        case 1:
          return '收银员扣款'
        default:
          return '其他'
      }
    },
    // 扣款
    handleWithhold () {
      this.$refs.modalWithhold.show()
    },
    // 扣款成功返回
    modalWithholdOk () {
      // this.loadData()
    },
    // 验证优惠劵
    handleVerify () {
      this.$refs.modalVerify.show()
    },
    // 确认手机推送的优惠劵
    handlePushAffirm () {
      window.ws.send(JSON.stringify({
        token: this.token,
        action: 'coupon_sure',
        mcid: this.pushId
      }))
      this.pushDialogVisible = false
    },
    // 获取WebsocketToken
    requestWebsocketToken (tokenType) {
      getWebsocketToken()
        .then(result => {
          if (result) {
            let that = this
            let token = result.data.token
            let host = result.data.host
            let port = result.data.port
            this.token = token
            if (!window.ws) {
              window.ws = new WebSocket((window.location.protocol === 'https:' ? 'wss' : 'ws') + '://' + host + ':' + port)
            } else {
              if (window.ws.readyState !== 1) {
                window.ws = new WebSocket((window.location.protocol === 'https:' ? 'wss' : 'ws') + '://' + host + ':' + port)
              }
            }
            window.ws.onopen = function () {
              window.ws.send(JSON.stringify({
                token: token,
                action: 'register'
              }))
            }
            window.ws.onmessage = function (evt) {
              let info = JSON.parse(evt.data)
              if (info.msgType === 'MEMBER_PAY') {
                that.getSpendStatistics()
                that.tableData.unshift(JSON.parse(info.msgBody))
              }
              if (info && info.msgType === 'register' && info.msgBody === 'success') {
                console.log('连接成功')
                if (tokenType === 'refresh') {
                  that.handlePushAffirm()
                }
              }
              if (info && info.msgType === 'AUTH' && info.msgBody === 'Token expired') {
                that.requestWebsocketToken('refresh')
              }
              if (info && info.msgType === 'coupon_use') {
                that.pushId = JSON.parse(info.msgBody).id
                that.pushmemberInfo = JSON.parse(info.msgBody)
                that.pushDialogVisible = true
              }
            }
            window.ws.onclose = function () {
              console.log('onclose')
              // 关闭 websocket
            }
          }
        })
    },
    // 实时收银
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      lastSpend(data)
        .then(result => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        }).catch(error => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    // 确认金额
    getConfirmSpend (ids) {
      let data = new FormData()
      data.append('ids', ids)
      confirmSpend(data)
        .then(result => {
          if (result) {
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
    },
    handleAllAffirm () {
      let ids = []
      this.tableData.forEach((item) => {
        ids.push(item.id)
      })
      this.$confirm('确认本页消费金额, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getConfirmSpend(ids.join(','))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleAffirm (ids) {
      this.$confirm('确认消费金额, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getConfirmSpend(ids)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 修改金额
    getHandleSpend (mid, amount) {
      let data = new FormData()
      data.append('mid', mid)
      data.append('amount', amount)
      handleSpend(data)
        .then(result => {
          if (result) {
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
    },
    handleEdit (mid) {
      this.$prompt('请输入金额', '修改金额', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^([1-9]\d*(\.\d*)?)$|^0\.\d*[1-9]\d*$/,
        inputErrorMessage: '金额格式不正确'
      }).then(({ value }) => {
        this.getHandleSpend(mid, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    // 消费统计
    getSpendStatistics () {
      spendStatistics()
        .then(result => {
          if (result) {
            this.statisticsInfo = result.data
          }
        })
    },
    // 刷新
    refresh () {
      this.loadData()
      this.getSpendStatistics()
    },
    // 备注
    handleRemark (params) {
      this.params = params
      this.desc = params.remark
      this.dialogVisible = true
    },
    handleClose () {
      this.params = {}
      this.desc = ''
      this.dialogVisible = false
    },
    handleAffirmRemark () {
      let data = new FormData()
      data.append('id', this.params.id)
      data.append('remark', this.desc)
      setSpendRemark(data)
        .then(result => {
          if (result) {
            this.dialogVisible = false
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        }).catch(error => {
          if (error) {
          }
        })
    }

  },
  mounted () {
    this.refresh()
    this.requestWebsocketToken(null)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/RealApp/Real.vue